import styled from 'styled-components'

export const LogoImg = styled.img`
  height: 2.5rem;
  display: block;
`
